export default function Footer({handleStartOver}) {
  return (
    <div id="footer">
      <button onClick={handleStartOver}>Start Over</button><br/>
      <br/>
      {process.env.REACT_APP_VERSION}
    </div>
  )
}